import React from 'react';
import Container from 'common/components/UI/Container';
import { DOCS_LINKS } from 'common/data/launch';
import ScreenImage from '../../Custom/ScreenImage';
import { Intro, Topic } from '../SavingsWorkspace/savingsworkspace.style';
import { AgenticWrapper, FactList, Closing, Shot } from './agenticfinops.style';

const FACTS = [
  {
    lead: 'Off by default.',
    text: 'Turn it on in Settings when you want it.',
  },
  {
    lead: 'Local only.',
    text:
      'The server listens on 127.0.0.1 and asks for a token generated on your computer.',
  },
  {
    lead: 'Nothing changes in your AWS account.',
    text:
      'It never modifies AWS resources, never exposes your credentials, and cannot apply a fix.',
  },
  {
    lead: 'Twelve tools.',
    text:
      'Nine read the data CloudPouch already holds locally. The other three refresh cost data, start a Savings Scan that CloudPouch runs itself in plain view in the app, and report the scan\'s progress.',
  },
  {
    lead: 'Five assistants.',
    text:
      "Guided setup for Claude Code, Claude Desktop, Cursor, Codex and Kiro: copy a command or a config snippet from Settings. CloudPouch never edits another app's files.",
  },
];

const AgenticFinOpsSection = () => (
  <AgenticWrapper id="agentic_finops">
    <Container>
      <Intro>
        <span>AGENTIC FINOPS</span>
        <h2>Ask your AI assistant about your own AWS costs</h2>
        <p>
          CloudPouch can share its cost and savings data with your AI assistant
          over MCP, straight from the running app. Ask in plain language how
          your costs changed since last month or what the last Savings Scan
          found, and the answer comes from your data instead of a model's
          guess.
        </p>
      </Intro>

      <FactList>
        {FACTS.map((fact) => (
          <Topic as="li" key={fact.lead}>
            <strong>{fact.lead}</strong> {fact.text}
          </Topic>
        ))}
      </FactList>

      <Closing>
        <p>
          Free includes the built-in MCP server for your AI Agents. Pro adds
          saved run history and per-opportunity detail with evidence. Your
          assistant decides where the answers it reads go next, because that
          part sits outside CloudPouch. Claude Desktop setup needs Node 18 or
          newer.
        </p>
        {/* Docs are a separate release: check this URL returns 200 first. */}
        <a href={DOCS_LINKS.connectAssistant}>Connect your assistant</a>
      </Closing>

      <Shot>
        <ScreenImage
          name="cloudpouch-2-mcp-assistant"
          alt="Claude Code in a terminal, asked which three ACME-prod recommendations give the biggest savings for the least work or risk. It called the cloudpouch tools 7 times and answers with three ranked recommendations, each with its estimated monthly saving, effort and risk."
          sizes="(min-width: 1220px) 960px, (min-width: 992px) 910px, (min-width: 768px) 690px, calc(100vw - 60px)"
        />
        <figcaption>
          Claude Code answering a question from CloudPouch data.
        </figcaption>
      </Shot>
    </Container>
  </AgenticWrapper>
);

export default AgenticFinOpsSection;
